import { Tag, Gift, Percent, Heart } from 'lucide-react';

const IMG = '/images/specials/';
const V = '?v=2';

export const specials = [
  {
    id: 1,
    slug: 'fall-furnace-tune-up-99',
    title: '$99 Fall Furnace Tune-Up',
    tagline: 'Cold fronts don\'t call ahead.',
    description: 'Make sure your heating system is ready for winter! Our comprehensive tune-up includes a 21-point inspection, filter replacement, and safety check.',
    badge: 'SAVE $40',
    icon: Tag,
    accent: 'bg-orange-500',
    image: `${IMG}fall-furnace.webp${V}`,
    code: null,
    price: '99',
    regularPrice: '139',
    validUntil: '2026-11-30',
    serviceName: 'Furnace Tune-Up',
    includes: [
      '21-point furnace inspection',
      'Standard filter replacement',
      'Burner, igniter & flame sensor cleaning',
      'Heat exchanger & carbon monoxide safety check',
      'Thermostat calibration',
      'Electrical connection tightening'
    ],
    finePrint: 'Valid for one standard residential gas or electric furnace. Additional systems quoted separately. Not valid with other offers. Valid in ComfortMaster service area only.'
  },
  {
    id: 2,
    slug: 'new-customer-10-off',
    title: '10% Off for New Customers',
    tagline: 'Welcome to the ComfortMaster family.',
    description: 'First time using ComfortMaster? Enjoy 10% off on any service repairs. We appreciate you giving us a try!',
    badge: '10% OFF',
    icon: Percent,
    accent: 'bg-blue-500',
    image: `${IMG}new-customer-welcome.webp${V}`,
    altImages: [`${IMG}new-customer-fast-service.webp${V}`],
    code: 'NEWCUSTOMER10',
    price: '0',
    validUntil: '2026-12-31',
    serviceName: 'HVAC Repair',
    includes: [
      '10% off any heating, cooling, or plumbing repair',
      'Upfront pricing before any work begins',
      'NATE-certified technicians',
      'Applies to parts and labor'
    ],
    finePrint: 'First-time residential customers only. Mention code when booking. Maximum discount $250. Not valid on system replacements, maintenance plans, or with other offers.'
  },
  {
    id: 3,
    slug: 'heroes-seniors-10-off',
    title: '10% Off for Veterans, First Responders, Teachers & Seniors',
    tagline: 'Thank you for serving our community.',
    description: 'We proudly support those who serve our community! Veterans, First Responders, Teachers, and Senior Citizens receive 10% off any service. Thank you for all you do!',
    badge: '10% OFF',
    icon: Heart,
    accent: 'bg-red-500',
    image: `${IMG}heroes.webp${V}`,
    code: 'HEROES10',
    price: '0',
    validUntil: '2026-12-31',
    serviceName: 'HVAC Service',
    includes: [
      '10% off any service call or repair',
      'Available to active & retired military, police, fire, EMS',
      'Available to K-12 teachers and seniors 65+',
      'Can be used year-round'
    ],
    finePrint: 'Valid ID or proof of service required at time of service. Maximum discount $250. Not valid with other offers or on system replacements.'
  },
  {
    id: 4,
    slug: 'free-uv-bulb-system-replacement',
    title: 'Free UV Bulb with System Change Out',
    tagline: 'Upgrade your system. Purify your air.',
    description: 'Get a FREE UV bulb with any full system change out. Improve your air quality while upgrading your system.',
    badge: 'FREE',
    icon: Gift,
    accent: 'bg-violet-500',
    image: `${IMG}uv-bulb.webp${V}`,
    code: 'UVBULB2026',
    price: '0',
    validUntil: '2026-12-31',
    serviceName: 'HVAC System Replacement',
    includes: [
      'Germicidal UV light installed in your air handler',
      'Helps reduce mold, bacteria & viruses on the coil',
      'Keeps evaporator coil cleaner & more efficient',
      'Installed with your new system at no extra charge'
    ],
    finePrint: 'Requires purchase and installation of a complete heating and cooling system. One UV bulb per qualifying installation. Not redeemable for cash.'
  },
  {
    id: 5,
    slug: 'system-tune-up-99',
    title: '$99 System Tune-Up',
    tagline: 'Ready for every Kentucky season.',
    description: 'Make sure your HVAC system is ready for seasonal changes. Includes comprehensive inspection and cleaning.',
    badge: 'SAVE $40',
    icon: Tag,
    accent: 'bg-emerald-500',
    image: `${IMG}system-tune-up.webp${V}`,
    code: null,
    price: '99',
    regularPrice: '139',
    validUntil: '2026-12-31',
    serviceName: 'HVAC Tune-Up',
    includes: [
      'Complete AC or heat pump inspection',
      'Condenser coil rinse & debris removal',
      'Refrigerant level & pressure check',
      'Capacitor, contactor & electrical test',
      'Condensate drain line flush',
      'Airflow & temperature split measurement'
    ],
    finePrint: 'Valid for one residential system. Refrigerant and repair parts are extra if needed. Not valid with other offers. Valid in ComfortMaster service area only.'
  }
];

export const isSpecialActive = (special) => new Date() <= new Date(`${special.validUntil}T23:59:59`);

export const getActiveSpecials = () => specials.filter(isSpecialActive);

export const getAdSlides = () => {
  const active = getActiveSpecials();
  const alts = active.flatMap((special) => (special.altImages || []).map((image, i) => ({ special, image, v: i + 1 })));
  return [...active.map((special) => ({ special, image: special.image, v: 0 })), ...alts];
};

const SEASONAL_OFFER = {
  spring: 'system-tune-up-99',
  summer: 'system-tune-up-99',
  fall: 'fall-furnace-tune-up-99',
  winter: 'fall-furnace-tune-up-99'
};

export const getSeasonalSpecial = (season) => {
  const active = getActiveSpecials();
  return active.find(s => s.slug === SEASONAL_OFFER[season]) || active.find(s => s.slug === 'system-tune-up-99') || null;
};
